<template>
  <div class="lstIzin">
    <div class="col-12">
      <div class="list-group">
        <div v-for="(item, index) in listOfizin" :key="index" class="py-1 px-2">
          <a
            :href="`/pdfcuti?nama=${nama}&awal=${item.tanggal_awal_cuti}&akhir=${item.tanggal_akhir_cuti}&masuk=${item.tanggal_masuk}&ket=${item.keterangan}&kontak=${kontak}&now=${tglsaatini}&entitas=${item.id_entitas}`"
            class="list-group-item list-group-item-action"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Pengajuan Cuti</h5>
              <!-- <small class="text-muted">{{ item.created_on }}</small> -->
            </div>
            <p class="mb-1">
              Tanggal Awal Cuti : {{ formatDate(item.tanggal_awal_cuti) }}
            </p>
            <p class="mb-1">
              Tanggal Akhir Cuti : {{ formatDate(item.tanggal_akhir_cuti) }}
            </p>
            <p class="mb-0">Lama Cuti : {{ item.total_cuti_diambil }} hari</p>
            <p class="mb-1">Keterangan : {{ item.keterangan }}</p>
            <small class="text-muted" v-if="item.status == 0">Pending</small>
            <small class="text-success" v-else-if="item.status == 1"
              >Disetujui</small
            >
            <small class="text-danger" v-else>Tidak Disetujui</small>
          </a>
        </div>
        <button
          type="button"
          class="btn btn-succes btn-sm"
          :class="{ 'd-none': btnDisabled }"
          @click.prevent="loadMore(page)"
        >
          {{ btnLoadMoreName }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios");
const Swal = require("sweetalert2");
import moment from "moment";
export default {
  data() {
    return {
      page: 2,
      id: localStorage.getItem("id"),
      listOfizin: [],
      dataEmpty: true,
      btnDisabled: false,
      btnLoadMoreName: "Muat Lebih Banyak",
      nama: localStorage.getItem("nama"),
      kontak: "xxxxxxx",
      tglsaatini: new Date().toISOString().slice(0, 10),
      headers: "",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    loadMore(pages) {
      try {
        axios
          .post(
            this.UrlApi + "listcuti/setuju?page=" + pages,
            {
              id: this.id,
            },
            { headers: this.headers }
          )
          .then((res) => {
            if (res.data.success && res.data.success !== null) {
              // this.dataEmpty = res.data.data.length > 0 ? true : false;
              if (res.data.data.length > 0) {
                this.page += 1;
                Array.prototype.push.apply(this.listOfizin, res.data.data);
                // console.log(this.listOfizin);
              } else {
                this.btnLoadMoreName = "Data Sudah Diload Seluruhnya";
                this.btnDisabled = true;
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: res.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    getKontak() {
      try {
        axios
          .post(
            this.UrlApi + "pegawai/show",
            {
              id: this.id,
            },
            { headers: this.headers }
          )
          .then((res) => {
            if (res.data.success && res.data.success !== null) {
              this.kontak = res.data.data[0].no_tlp;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
  created() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("key"),
    };

    try {
      axios
        .post(
          this.UrlApi + "listcuti/setuju?page=",
          {
            id: this.id,
          },
          { headers: this.headers }
        )
        .then((res) => {
          if (res.data.success && res.data.success !== null) {
            this.dataEmpty = res.data.data.length > 0 ? true : false;
            this.listOfizin = res.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("error response");
          } else if (err.request) {
            console.log("error request");
          } else {
            console.log("error");
          }
        });
    } catch (error) {
      console.log(error);
    }

    this.getKontak();
  },
};
</script>
